// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import {
  operationPermissions,
} from '../../helpers/permissions'

const { axiosIns } = useJwt
// const baseUrl = 'https://sandbox-base-operations.udara360.io/api'
export default {
  getAuditTrails: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/AuditTrail/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.AUDIT_TRAIL)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAuditUsers: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/User/v1/SimpleSearch')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOtherBusinessAccount: async (context, { search, page, limit = 10 }) => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const url = generateSearchQuery({
        filter: search,
        url: '/accounting/api/OtherBusinessAutomation/v1/Search',
        currentPage: page,
        perPage: limit,
      })
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createOtherBusinessAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/OtherBusinessAutomation/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOtherBusinessAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/OtherBusinessAutomation/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllBranches: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/Branch/v1/GetAll')
      commit('setBranches', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllUsers: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/base/api/User/v1/Search?status=${formData.status}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUserPhoneNumberById: async (context, id) => {
    try {
      const response = await axiosIns.get(`/base/api/User/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBranchList: async ({ dispatch }, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Branch/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      dispatch('getAllBranches', { permission })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBranchByCode: async (context, code) => {
    try {
      const response = await axiosIns.get(`/base/api/Branch/v1/GetByCode?code=${code}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateBranchAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BRANCH)
      const response = await axiosIns.put('/base/api/Branch/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createBranchAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BRANCH)
      const response = await axiosIns.post('/base/api/Branch/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateStatus: async (context, {
    routeName, actionType, permission, statusValues,
  }) => {
    try {
      let route
      if (actionType === 'Active') {
        route = 'Activate'
      } else if (actionType === 'InActive') {
        route = 'Deactivate'
      } else {
        route = 'Disable'
      }
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/base/api/${routeName}/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOpenCloseStatus: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/base/api/Branch/v1/UpdateBranchOperationStatus', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllRegions: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_REGION)
      const response = await axiosIns.get('/base/api/Region/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRegionList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Region/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_REGION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateRegionAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_REGION)
      const response = await axiosIns.put('/base/api/Region/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createRegionAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_REGION)
      const response = await axiosIns.post('/base/api/Region/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOtherConfigurationAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateOtherConfiguration', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOtherConfigurationList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveOtherConfigurations')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateEODConfigurationAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateEODConfiguration', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEODConfigurationList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveEODConfiguration')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterestInformationList: async (context, { permission = operationPermissions.VIEW_SYSTEM_SETUP }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveInterestInformation')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInterestInformationAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateInterestInformation', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInstitutionFileUploadAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/admin/api/Institution/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateSignatureFileUpload: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/admin/api/Institution/v1/AddDocumentSignatory', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInstitutionFileUploadList: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/admin/api/Institution/v1/GetUXAttributes')
      commit('setInstitutionData', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDigitalSignatureFiles: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/admin/api/Institution/v1/GetDocumentSignatories')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // updateInstitutionFileUploadAction: async (context, data) => {
  //   try {
  //     useJwt.setPermission(operationPermissions.MOIDFY_SYSTEM_SETUP)
  //     const response = await axiosIns.post(
  //       '/admin/api/Institution/v1/uploadimages',
  //       data,
  //     )
  //     return Promise.resolve(response)
  //   } catch (error) {
  //     return Promise.reject(error)
  //   }
  // },
  // getInstitution: async ({ commit }, subDomain) => {
  //   try {
  //     const response = await axiosIns.get(`/admin/api/Institution/v1/GetBasicDetailsBySubDomainName?subDomainName=${subDomain}`)
  //     const { data } = await response
  //     commit('setInstitution', data)
  //     return Promise.resolve(response)
  //   } catch (error) {
  //     return Promise.reject(error)
  //   }
  // },
  updateTaxInformationAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateTaxInformation', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateWorkingDaysAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateWorkingDays', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getWorkingDaysList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveWorkingDays')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTaxInformationList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveTaxInformation')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPublicHolidayList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrievePublicHolidays')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createPublicHolidayAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.post('/base/api/SystemConfig/v1/AddPublicHoliday', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updatePublicHolidayAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdatePublicHoliday', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deletePublicHolidayAction: async (context, id) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.delete(`/base/api/SystemConfig/v1/DeletePublicHoliday?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getThresholdConfigList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveThresholdAlert')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateThresholdConfiguration: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateThresholdAlert', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCashHandlingLimit: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveCashHandlingLimit')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCashHandlingLimitAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateCashHandlingLimit', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  updateAccountTierLevelAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateAccountTierConfig', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountTierLevelList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_SYSTEM_SETUP)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveAccountTiers')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getWebhookConfigList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/admin/api/Institution/v1')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateWebhookConfigAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/admin/api/Institution/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCorporateInformationAction: async (context, data) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_SYSTEM_SETUP)
      const response = await axiosIns.put('/base/api/SystemConfig/v1/UpdateCorporateInformation', data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCorporateInformationList: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/SystemConfig/v1/RetrieveCorporateInformation')
      commit('corporateInformation', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getApprovals: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Approval/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_ALL_APPROVALS)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getApproval: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/base/api/Approval/v1?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getApprovalRequests: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Approval/v1/SearchInitiatorApprovalRequests',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_MY_APPROVALS)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPendingApprovalRequests: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/Approval/v1/GetUserPendingRequestsToApprove',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_PENDING_APPROVALS)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  processApproval: async (context, { approvalData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/base/api/Approval/v1/Process', approvalData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateApproval: async (context, { approvalData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/base/api/Approval/v1/Update', approvalData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createApprovalConfiguration: async (context, formData) => {
    try {
      const response = await axiosIns.put('/base/api/ApprovalConfiguration/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getApprovalConfiguration: async (context, { id }) => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_APPROVAL_SETUP)
      const response = await axiosIns.get(`/base/api/ApprovalConfiguration/v1/GetByPermission?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getApprovalConfigurations: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/ApprovalConfiguration/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deleteApprovalConfiguration: async (context, id) => {
    try {
      const response = await axiosIns.delete(`/base/api/ApprovalConfiguration/v1/Delete?id=${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createTillAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/TillAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateTillAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/TillAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTillAccountList: async ({ commit }, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/TillAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      commit('setTillAccount', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createVaultAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/VaultAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateVaultAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/VaultAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getVaultAccountList: async ({ commit }, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/VaultAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      commit('setVaultAccount', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  createMobileTillAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/MobileTillAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateMobileTillAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/MobileTillAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMobileTillAccountList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/MobileTillAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUsersByBranchCode: async (context, branchCode) => {
    try {
      const response = await axiosIns.get(`/base/api/User/v1/GetByBranchCode?branchCode=${branchCode}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createShortagesAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/ShortagesAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateShortagesAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/ShortagesAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getShortagesAccountList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/ShortagesAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createOverageAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/OverageAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOverageAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/OverageAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverageAccountList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/OverageAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createInterBranchAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/InterBranchTransactionAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInterBranchAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/InterBranchTransactionAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterBranchAccountList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/InterBranchTransactionAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBanks: async ({ commit }) => {
    try {
      const response = await axiosIns.get('/accounting/api/BusinessAutomation/v1/GetBanks')
      commit('setBanks', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getChequeClearingAccountList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/ChequeClearingAccount/v1/Search',
      currentPage: page,
      perPage: limit,
      permission,
    })
    try {
      // useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createChequeClearingAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/ChequeClearingAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateChequeClearingAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/ChequeClearingAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getChequeReceivableAccountList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/ChequeReceivableAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createChequeReceivableAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/ChequeReceivableAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateChequeReceivableAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/ChequeReceivableAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUnclearedChequeAccountList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/UnclearedChequeAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createUnclearedChequeAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/UnclearedChequeAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateUnclearedChequeAccountAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/UnclearedChequeAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCashSuspenseList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CashSuspenseAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_BUSINESS_AUTOMATION)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCashSuspenseAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_BUSINESS_AUTOMATION)
      const response = await axiosIns.post('/accounting/api/CashSuspenseAccount/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCashSuspenseAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_BUSINESS_AUTOMATION)
      const response = await axiosIns.put('/accounting/api/CashSuspenseAccount/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deleteBusinessAutomation: async (context, { routeName, id }) => {
    try {
      const response = await axiosIns.post(`/accounting/api/${routeName}/v1/Delete`, { id })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBusinessList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/BusinessOperations/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.OPEN_CLOSE_BUSINESS)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCurrentFinancialDate: async ({ commit }, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/base/api/BusinessOperations/v1/GetBusinessFinancialDateRecord')
      commit('setCurrentFinancialDate', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  setBusinessStatus: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.OPEN_CLOSE_BUSINESS)
      const response = await axiosIns.post('/base/api/BusinessOperations/v1/UpdateBusinessOperationState', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCommunicationApiAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.ADD_COMMS_TEMPLATE)
      const response = await axiosIns.post('/comms/api/CommunicationTemplate/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCommunicationApiAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_COMMS_TEMPLATE)
      const response = await axiosIns.put('/comms/api/CommunicationTemplate/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEventNames: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_COMMS_TEMPLATE)
      const response = await axiosIns.get('/comms/api/CommunicationTemplate/v1/GetEventNames')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEntityByEntityListenerIndex: async (context, eventIndex) => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_COMMS_TEMPLATE)
      const response = await axiosIns.get(
        `/comms/api/CommunicationTemplate/v1/GetEntityByEntityListener?eventName=${eventIndex}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEntityByObjectID: async (context, objectID) => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_COMMS_TEMPLATE)
      const response = await axiosIns.get(
        `/comms/api/CommunicationTemplate/v1/GetEntitiesByObjectID?objectID=${objectID}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCommunicationList: async () => {
    try {
      useJwt.setPermission(operationPermissions.VIEW_COMMS_TEMPLATE)
      const response = await axiosIns.get('/comms/api/CommunicationTemplate/v1/GetAll')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCommunicationStatus: async (context, { statusValues, actionType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const route = actionType === 'Active' ? 'Activate' : 'Deactivate'
      const response = await axiosIns.put(`/comms/api/CommunicationTemplate/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getcustomFieldList: async (context, { search, page, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/base/api/CustomField/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(operationPermissions.VIEW_CUSTOM_FIELD)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCustomFieldAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.CREATE_CUSTOM_FIELD)
      const response = await axiosIns.post('/base/api/CustomField/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postBulkSMSActions: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/comms/api/Sms/v1/Broadcast', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSMSWalletActions: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/comms/api/Sms/v1/GetSMSBalance', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getKYCWalletActions: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/kyc/api/Kyc/v1/GetBalance', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postRecomputeEODBalance: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/eodservice/api/EndOfDayConfig/v1/ManualTrialBalancing', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomFieldAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_CUSTOM_FIELD)
      const response = await axiosIns.put('/base/api/CustomField/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomFieldStatus: async (context, { statusValues, actionType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const route = actionType === 'Active' ? 'Activate' : 'Deactivate'
      const response = await axiosIns.put(`/base/api/CustomField/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCurrencies: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/Currency/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCurrencyRates: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/CurrencyRateConfig/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCurrencyRateAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.MODIFY_CURRENCY_RATE)
      const response = await axiosIns.put('/accounting/api/CurrencyRateConfig/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCurrencyRateAction: async (context, formData) => {
    try {
      useJwt.setPermission(operationPermissions.ADD_CURRENCY_RATE)
      const response = await axiosIns.post('/accounting/api/CurrencyRateConfig/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getEmailReportLists: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/comms/api/Email/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSMSReportLists: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/comms/api/Sms/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  deleteDocumentsUpload: async (context, { signatureId, permission }) => {
    try {
      useJwt.setPermission(permission)

      const response = await axiosIns.get(
        `/admin/api/Institution/v1/DeleteDocumentSignature?signatureId=${signatureId}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
